
import { useState } from 'react';
import { A2AMessage, A2AAgent } from '@/utils/a2a/types';
import { createPeerChannel, findBestPeerForCapability, CommunicationType } from '@/utils/a2a/communication/peerToPeer';

export const usePeerCommunication = () => {
  const [peerMessages, setPeerMessages] = useState<A2AMessage[]>([]);

  const sendPeerMessage = (fromAgent: string, toAgent: string, content: string, type: CommunicationType) => {
    try {
      const message = createPeerChannel(
        fromAgent,
        toAgent,
        type,
        content
      );
      
      setPeerMessages(prev => [...prev, message]);
      return message;
    } catch (error) {
      console.error("Error in sendPeerMessage:", error);
      return null;
    }
  };

  const findBestPeerAgent = (fromAgent: string, capability: string, availableAgents: A2AAgent[]) => {
    return findBestPeerForCapability(fromAgent, capability, availableAgents);
  };

  const cleanupOldPeerMessages = () => {
    const thirtyMinutesAgo = new Date(Date.now() - 30 * 60 * 1000);
    setPeerMessages(prev => 
      prev.filter(msg => new Date(msg.timestamp) > thirtyMinutesAgo)
    );
  };

  return {
    peerMessages,
    sendPeerMessage,
    findBestPeerAgent,
    setPeerMessages,
    cleanupOldPeerMessages
  };
};
